<header>
  <mat-toolbar>
    <div class="title-wrapper">
      <div class="title">
        <img src="assets/icons/R360-icon.svg" />
        <a [routerLink]="'/'">
          <span
            [ngClass]="{
              uppercase: true,
              'toolbar-title': true,
              'toolbar-title-collapsed': drawerService.sidenavCollapsed$ | async
            }">
            <ng-container i18n>Reliability 360™ Dashboard</ng-container>
          </span>
        </a>
      </div>
      <span class="appversion">{{ this.appConfigService.appVersion }}</span>
    </div>
    <div class="user-wrapper">
      <div class="menus">
        @if ((this.tenantService.tenants$ | async)?.length! >= 1) {
          <tenant-menu class="tenant-menu"></tenant-menu>
        }

        <div id="user-voice">
          <img class="icon" [src]="'assets/icons/uservoice-icon.svg'" />
        </div>

        <!-- <notification-menu></notification-menu> -->
        <user-menu></user-menu>
      </div>
    </div>
  </mat-toolbar>
</header>
